export default "__VITE_ASSET__5le8CQWZ__"